import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import navbarData from '../data/NavbarData'
import Axios from 'axios';
import * as gr from 'react-icons/gr';
import Logout from '../helpers/Logout';
import SearchBox from './HomeHeader/SearchBox';

export default function HomeHeader() {

    const [user, setUser] = useState([]);

    useEffect(async () => {
        try
        {
            const url = `https://docsserver.onrender.com/user/getUserData`;
            let res = await Axios.get(url);
            if(res.data.length !== 0)
            {
                //console.log(res.data[0]);
                setUser(res.data[0]);
            }
        }

        catch(err)
        {
            //console.log("Some error");
            //console.log(err);
        }
    }, [])

  return (
    <nav className='bg-white sticky top-0 z-50 shadow-lg'>
        <div className='py-2 px-6 mx-auto border'>
            <div className='flex justify-between items-center'>
                {/* //! Primary and Logo Nav */}
                <div className='flex items-center'>

                    <div className='flex items-center mr-10 space-x-1'>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                        </svg>
                        <span className='text-2xl text-gray-600 font-semibold main-font'>Docx</span>
                    </div>
                </div>

                {/* //! Search Bar */}
               <SearchBox />

                {/* //! SECONDARY Nav */}
                
                <div className='flex items-center space-x-3'>
                    <a href='https://workspace.google.com/' className='mr-1' target='_'><gr.GrApps className='text-gray-400' size={28}/></a>
                    <div className='group relative'>
                        <img src={user.img} className='w-12 h-8 rounded-full cursor-pointer'></img>
                        <div className='absolute z-10 hidden group-hover:block bg-white right-1 shadow-lg'>
                            <a className='py-3 pl-6 pr-8 hover:bg-slate-100 cursor-pointer flex' href='https://myaccount.google.com/personal-info?hl=en' target="_blank" >My Account</a>
                            <p onClick={() => Logout()} className='py-3 pl-6 pr-8 hover:bg-slate-100 cursor-pointer flex'><svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>Logout</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </nav>
  )
}
